// SKH: main-image prev/next overlay arrows drive slide switching via the same
// thumbnail-click mechanism Dawn already uses on desktop (the main slider's own
// scroll-based nav only applies at mobile widths where the list is horizontally
// scrollable; on desktop the underlying <ul> has overflow: visible, so a plain
// scrollBy prev/next never moves anything -- clicking the matching thumbnail is
// how Dawn actually switches the active slide there).
//
// Everything here only matters for the vertical thumbnail rail, which only exists
// at the same >=750px breakpoint as its CSS (assets/section-main-product.css).
// On mobile Dawn's stock carousel already works correctly on its own -- running
// this unconditionally caused a real bug there: the MutationObserver below was
// watching the whole document for any 'disabled' attribute change to un-stick the
// rail's own buttons, but that also fires on every disabled toggle Shopify's variant
// -swap AJAX flow does on unrelated buttons (add-to-cart, quantity) during its own
// re-render, and the extra work was enough to interfere with that flow on mobile
// hardware. Now scoped to desktop width and to media-gallery elements only.
if (window.matchMedia('(min-width: 750px)').matches) {
  function skhEnableRailButtons() {
    document.querySelectorAll('media-gallery slider-component.thumbnail-slider .slider-button[disabled]').forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('disabled');
    });
  }
  skhEnableRailButtons();
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    new MutationObserver(skhEnableRailButtons).observe(gallery, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true,
    });
  });

  document.addEventListener('click', function (e) {
    // Capture phase: Dawn's slider-component.js has its own click handler on the
    // thumbnail-rail buttons that stops propagation (it does horizontal scrollLeft
    // logic, irrelevant to our vertical rail) -- run before that so it doesn't
    // swallow the event.
    var mainBtn = e.target.closest('slider-component.slider-mobile-gutter .slider-buttons .slider-button');
    if (mainBtn) {
      var mediaGallery = mainBtn.closest('media-gallery');
      if (!mediaGallery) return;
      var activeSlide = mediaGallery.querySelector('.product__media-item.is-active');
      if (!activeSlide) return;
      var items = Array.from(mediaGallery.querySelectorAll('.thumbnail-list__item'));
      if (!items.length) return;
      var targets = items.map(function (li) { return li.dataset.target; });
      var activeId = activeSlide.id.replace('Slide-', '');
      var idx = targets.indexOf(activeId);
      if (idx === -1) return;
      var dir = mainBtn.classList.contains('slider-button--next') ? 1 : -1;
      var next = idx + dir;
      if (next < 0) next = targets.length - 1;
      if (next >= targets.length) next = 0;
      var thumb = items[next].querySelector('.thumbnail');
      if (thumb) thumb.click();
      return;
    }

    // Thumbnail rail's own prev/next: Dawn's slider-component.js scrolls scrollLeft,
    // but the rail is a vertical column here (overflow-y, scrollTop), so drive it directly.
    var railBtn = e.target.closest('slider-component.thumbnail-slider .slider-button');
    if (railBtn) {
      var list = railBtn.closest('slider-component').querySelector('.thumbnail-list');
      if (!list) return;
      var step = list.clientHeight * 0.9;
      var dir2 = railBtn.classList.contains('slider-button--next') ? 1 : -1;
      list.scrollBy({ top: step * dir2, behavior: 'auto' });
    }
  }, true);
}

// SKH: live character counter for the ring personalization field. Not width-scoped
// (unlike the gallery nav code above) since the field is used on mobile too.
document.addEventListener('input', function (e) {
  if (!e.target.classList || !e.target.classList.contains('skh-ring-personalization__input')) return;
  var wrapper = e.target.closest('.skh-ring-personalization__content');
  var counter = wrapper && wrapper.querySelector('.skh-ring-personalization__count-current');
  if (counter) counter.textContent = e.target.value.length;
});

// SKH: on desktop the media (left) column runs shorter than the info (right)
// column and leaves a dead gap below the gallery, while the delivery-estimate
// widget crowds the bottom of the already-busy right column. Move the same
// element into the media column instead of duplicating it. 990px matches the
// breakpoint the media/info column width split already uses.
function skhMoveDeliveryEstimate() {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  document.querySelectorAll('.skh-delivery-estimate').forEach(function (widget) {
    if (widget.dataset.skhMoved) return;
    var mediaWrapper = widget.closest('.product')?.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;
    mediaWrapper.appendChild(widget);
    widget.dataset.skhMoved = 'true';
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', skhMoveDeliveryEstimate);
} else {
  skhMoveDeliveryEstimate();
}
